export class OrderMismatchedDeliveryPriceError extends Error {
    constructor() {
        super('MISMATCHED_DELIVERY_PRICE');
    }
}
